export const CHALLENGES_PREFIX = 'challenges/';

export const CHALLENGES_REQUESTED = `${CHALLENGES_PREFIX}CHALLENGES_REQUESTED`;
export const CHALLENGES_SUCCEEDED = `${CHALLENGES_PREFIX}CHALLENGES_SUCCEEDED`;
export const CHALLENGES_FAILED = `${CHALLENGES_PREFIX}CHALLENGES_FAILED`;

export const CHALLENGE_UPDATE_REQUESTED = `${CHALLENGES_PREFIX}CHALLENGE_UPDATE_REQUESTED`;
export const CHALLENGE_UPDATE_SUCCEEDED = `${CHALLENGES_PREFIX}CHALLENGE_UPDATE_SUCCEEDED`;
export const CHALLENGE_UPDATE_FAILED = `${CHALLENGES_PREFIX}CHALLENGE_UPDATE_FAILED`;

export const PARTICIPATED_CHALLENGES_REQUESTED = `${CHALLENGES_PREFIX}PARTICIPATED_CHALLENGES_REQUESTED`;
export const PARTICIPATED_CHALLENGES_SUCCEEDED = `${CHALLENGES_PREFIX}PARTICIPATED_CHALLENGES_SUCCEEDED`;
export const PARTICIPATED_CHALLENGES_FAILED = `${CHALLENGES_PREFIX}PARTICIPATED_CHALLENGES_FAILED`;
